import React, { useEffect, useState } from "react";
import Accordion from "../../../common/accordion";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import { Info } from "../../../../assets/icons";
import TextInput from "../../../common/textinput";
import useTubingFacade from "../../../../facade/calculation/calculation-input/tubing.facade";
import useCableFacade from "../../../../facade/calculation/calculation-output/cable.facade";
import { CableAlertProps } from "../../../../store/model/calculations/cable";
import TextShortInput from "../../../common/TextShortInput";

const SurfaceVoltage: React.FC<CableAlertProps> = ({ setShowError }) => {
  const [input, setInput] = useState<{
    surfaceCableLength: string;
    CableLength: string;
  }>({
    surfaceCableLength: "",
    CableLength: "",
  });

  const { tab1Input } = useAppSelector((state) => state?.tubing);
  const { tab3Input } = useAppSelector((state) => state?.fluid);
  const { tab2Input } = useAppSelector((state) => state?.wellInput);
  const { surfaceVoltageCollapse } = useAppSelector((state) => state?.collapse);
  const {
    cableAmpacity,
    cableConductorTempDesign,
    cableMaxCondutorTemp,
    cableSurfaceVoltage,
    cableTotalLength,
    cableTotalVoltageLoss,
    cableVDrop,
    cableVoltageLoss1000,
  } = useAppSelector((state) => state?.cable);
  const { hdnCable_EstCabLng, hdnCable_SurfCabl } = useAppSelector(
    (state) => state?.tubing?.tab1Input || {}
  );

  useEffect(() => {
    if (
      (tab1Input?.unitSys == 0 && +cableVoltageLoss1000 > 30) ||
      (tab1Input?.unitSys == 1 && +cableVoltageLoss1000 > 98.425)
    )
      setShowError((prev: any) => ({ ...prev, voltageLossWarning: true }));
    else setShowError((prev: any) => ({ ...prev, voltageLossWarning: false }));
  }, [cableVoltageLoss1000]);

  useEffect(() => {
    if (cableVDrop && cableVDrop > 15) {
      setShowError((prev: any) => ({ ...prev, exceed15Warning: true }));
    } else {
      setShowError((prev: any) => ({ ...prev, exceed15Warning: false }));
    }
  }, [cableVDrop]);

  useEffect(() => {
    if (hdnCable_EstCabLng) {
      setInput({ ...input, CableLength: hdnCable_EstCabLng });
    }
    if (hdnCable_SurfCabl) {
      setInput({ ...input, surfaceCableLength: hdnCable_SurfCabl });
    }
  }, [hdnCable_EstCabLng, hdnCable_SurfCabl]);

  const { updateSurfaceVoltageCollapse } = useCollapseFacade();
  const { updateHiddenSurfaceCabl, updateHiddenCableEstCabLng } =
    useTubingFacade();
  const { updateCableTotalLength } = useCableFacade();

  const handleCollapseChange = (key: boolean) => {
    updateSurfaceVoltageCollapse(key);
  };

  const handleSurfaceChange = (value: string) => {
    if (value !== "" || hdnCable_SurfCabl !== "")
      updateHiddenSurfaceCabl(value);
  };

  const handleCableChange = (value: string) => {
    if (value !== "" || hdnCable_EstCabLng !== "") {
      updateCableTotalLength(+value || 0);
      updateHiddenCableEstCabLng(value);
    }
    if (value === "") {
      let val = +(tab2Input?.pumpSetting || 0) + +(hdnCable_SurfCabl || 0);
      updateCableTotalLength(val);
      updateHiddenCableEstCabLng(val);
    }
  };

  return (
    <Accordion
      tooltipText="Formulas"
      title="Surface voltage"
      link={"/help?tab=Cable#SurfaceVolt"}
      isOpen={surfaceVoltageCollapse}
      onToggle={() => handleCollapseChange(!surfaceVoltageCollapse)}
      content={
        <>
          <div className="flex justify-center p-4 gap-4 w-full">
            <div className="flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2">
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                <label className="text-neutral-25 text-[14px] font-normal">
                  Surface cable length
                </label>
                <div className="flex justify-end">
                  <TextShortInput
                    type="number"
                    className="px-[10px] py-[1px] w-[100px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
                    name="chargePumpDesrdStge"
                    onChange={(event) => {
                      setInput({
                        ...input,
                        surfaceCableLength: event.target.value,
                      });
                    }}
                    value={input?.surfaceCableLength}
                    onBlur={(event) => handleSurfaceChange(event.target.value)}
                  />
                  <label className="text-neutral-25 ml-1 mt-0">
                    {tab1Input?.actNameCable_SurfaceCableLength}
                  </label>
                </div>
              </div>
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                <label className="text-neutral-25">Cable length override</label>
                <div className="flex justify-end">
                  <TextShortInput
                    type="number"
                    className="px-[10px] py-[1px] w-[100px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
                    name="chargePumpDesrdStge"
                    onChange={(event) => {
                      setInput({ ...input, CableLength: event.target.value });
                    }}
                    value={input?.CableLength}
                    onBlur={(event) => handleCableChange(event.target.value)}
                  />
                  <label className="text-neutral-25 ml-1 mt-0">
                    {tab1Input?.actNameCable_EstCableLength}
                  </label>
                </div>
              </div>

              <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                <label className="text-neutral-25">Total cable length</label>
                <label className="text-neutral-25">
                  {cableTotalLength} {tab1Input?.actNameCable_EstCableLength}
                </label>
              </div>
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                <label className="text-neutral-25">
                  % V.Drop / Nm Plate motor volt
                </label>
                <span className="text-success-600 border border-success-600 px-3 py-1 rounded-md">
                  {cableVDrop} %
                </span>
              </div>
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full">
                <label className="text-neutral-25">Ampacity</label>
                <label className="text-neutral-25">{cableAmpacity} A</label>
              </div>
            </div>
            <div className="flex flex-col justify-between border-[1px] border-darkcolor-400 rounded-[8px] w-1/2">
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                <label className="text-neutral-25">
                  Cable volt loss/1000{" "}
                  {tab1Input?.actNameCable_SurfaceCableLength}
                </label>
                <label className="text-neutral-25">
                  {cableVoltageLoss1000} {tab1Input?.actNameCable_VoltageLoss}
                </label>
              </div>
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                <label className="text-neutral-25">
                  Total cable volt loss{" "}
                </label>
                <label className="text-neutral-25">
                  {cableTotalVoltageLoss} {tab1Input?.actNameCable_VoltageLoss}
                </label>
              </div>
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                <label className="text-neutral-25">
                  Surface volts @ {tab3Input?.operatngFreq} Hz
                </label>
                <label className="text-neutral-25">
                  {cableSurfaceVoltage} {tab1Input?.actNameCable_SurfaceVoltage}
                </label>
              </div>
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                <label className="text-neutral-25">
                  Max conductor temperature
                </label>
                <label className="text-neutral-25">
                  {cableMaxCondutorTemp}{" "}
                  {tab1Input?.actNameMotor_TOperatingTemp}
                </label>
              </div>
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full">
                <label className="text-neutral-25">
                  Conductor temperature @ {tab3Input?.operatngFreq} Hz
                </label>
                <span
                  style={{ color: "#F97066", borderColor: "#F97066" }}
                  className="border px-3 py-1 rounded-md"
                >
                  {cableConductorTempDesign}{" "}
                  {tab1Input?.actNameMotor_TOperatingTemp}
                </span>
              </div>
            </div>
          </div>
          <div className="flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-primary-600 border-darkcolor-400">
            <Info />
            <p className="text-[14px] font-bold leading-[20px] text-neutral-25">
              Note: Surface voltages requires motor to be selected.
            </p>
          </div>
        </>
      }
    />
  );
};

export default SurfaceVoltage;
